/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import './Footer.css';

import { AiFillFacebook, AiFillGoogleCircle, AiFillInstagram, AiFillTwitterCircle } from "react-icons/ai";


const Footer = () => {
  useEffect(() => {
    for (let i = 0; i < 128; i++) {
      const bubble = document.createElement('div');
      const size = 2 + Math.random() * 4;
      const distance = 6 + Math.random() * 4;
      const position = -5 + Math.random() * 110;
      const time = 2 + Math.random() * 2;
      const delay = -1 * (2 + Math.random() * 2);

      bubble.style.setProperty('--size', `${size}rem`);
      bubble.style.setProperty('--distance', `${distance}rem`);
      bubble.style.setProperty('--position', `${position}%`);
      bubble.style.setProperty('--time', `${time}s`);
      bubble.style.setProperty('--delay', `${delay}s`);

      bubble.classList.add('bubble');
      document.querySelector('.bubbles').appendChild(bubble);
    }
  }, []);

  return (

   <>
    <div className="footer">
      <div className="bubbles"></div>
      <div className="">
     
     </div>
    </div>




  
      <footer className="text-center text-lg-start text-white" style={{ backgroundColor: '', fontSize: '25px' }}>
        <div className="container p-4 pb-0" style={{fontSize: '28px' }}>


        

          <section className="p-3 pt-0 row d-flex align-items-center">
      
              <div className="col-md-7 col-lg-8 text-center text-md-start">
                <div className="p-3">
                  © 2023 Copyright
                </div>
              </div>

              <div className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
  <a className="btn btn-outline-light btn-floating m-1" role="button" style={{ fontSize: '2rem' }}>
    <AiFillFacebook />
  </a>
  <a className="btn btn-outline-light btn-floating m-1" role="button" style={{ fontSize: '2rem' }}>
    <AiFillTwitterCircle />
  </a>
  <a className="btn btn-outline-light btn-floating m-1" role="button" style={{ fontSize: '2rem' }}>
    <AiFillGoogleCircle />
  </a>
  <a className="btn btn-outline-light btn-floating m-1" role="button" style={{ fontSize: '2rem' }}>
    <AiFillInstagram />
  </a>
</div>

       
          </section>
        </div>
      </footer>
  


    </>
  );
};

export default Footer;










/* eslint-disable jsx-a11y/anchor-is-valid */
// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import {
//   AiFillGithub,
//   AiOutlineTwitter,
//   AiFillInstagram,
// } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";

// const footerStyle = {
//   backgroundColor: "#7d7ba1a9",
//   color: "white",
//   padding: "20px 0",
//   textAlign: "center",
// };

// const fabolousIconStyle = {
//   fontSize: "36px",
//   margin: "0 10px",
//   color: "#fff",
//   transition: "all 0.3s ease-in-out",
// };

// const Footer = () => {
//   let date = new Date();
//   let year = date.getFullYear();

//   return (
//     <Container fluid style={footerStyle}>
//       <Row>
//         <Col md="4">
//           <h3 style={{ fontFamily: "FabolousFont", fontSize: "24px" }}>
//             © {year} Your Website Name
//           </h3>
//           <p>
//             A brief description of your website or company. You can include
//             your mission, vision, or any other relevant information here.
//           </p>
//         </Col>
//         <Col md="4">
//           <ul className="list-inline">
//             <li className="list-inline-item">
//               <a
//                 href="https://github.com/yourgithub"
//                 className="fabolous-icon"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <AiFillGithub style={fabolousIconStyle} />
//               </a>
//             </li>
//             <li className="list-inline-item">
//               <a
//                 href="https://twitter.com/yourtwitter"
//                 className="fabolous-icon"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <AiOutlineTwitter style={fabolousIconStyle} />
//               </a>
//             </li>
//             <li className="list-inline-item">
//               <a
//                 href="https://linkedin.com/in/yourlinkedin"
//                 className="fabolous-icon"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaLinkedinIn style={fabolousIconStyle} />
//               </a>
//             </li>
//             <li className="list-inline-item">
//               <a
//                 href="https://instagram.com/yourinstagram"
//                 className="fabolous-icon"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <AiFillInstagram style={fabolousIconStyle} />
//               </a>
//             </li>
//           </ul>
//         </Col>
//         <Col md="4">
//           <h4>Contact Us</h4>
//           <p>
//             Email: contact@example.com
//             <br />
//             Phone: +1 (123) 456-7890
//           </p>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Footer;



